var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 407",
    width: 10,
    height: 10,
    fill: "#B1ACE2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 408",
    x: 1,
    y: 11,
    width: 10,
    height: 1,
    fill: "#B1ACE2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 409",
    x: 11,
    y: 12,
    width: 11,
    height: 1,
    transform: "rotate(-90 11 12)",
    fill: "#B1ACE2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopy);
export default __webpack_public_path__ + "static/media/ico_copy.644d43a0c37529ee3bc371ef7d250359.svg";
export { ForwardRef as ReactComponent };